import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { WeekStatsDTO } from "../../HubSpot/useGetSchedulerCloserStats.ts";
import { capSaturation, formatRate, weekLabel } from "./closerStatsFormat.ts";

function toPercent(rate: number | null): number | null {
  return rate === null ? null : Math.round(rate * 1000) / 10;
}

function percentTooltip(percentSeries: string) {
  return (value: unknown, name: string): [string | number, string] => {
    if (value === null || value === undefined) return ["—", name];
    if (name === percentSeries) return [formatRate(Number(value) / 100), name];
    return [Number(value), name];
  };
}

export function CrTrendChart({ weeks }: { weeks: WeekStatsDTO[] }) {
  const data = weeks.map((w) => ({
    label: weekLabel(w.weekStart),
    callsDone: w.callsDone,
    wonDeals: w.wonDeals,
    cr: w.callsDone === 0 ? null : toPercent(w.cr),
  }));

  return (
    <ResponsiveContainer width="100%" height={260}>
      <ComposedChart
        data={data}
        margin={{ top: 16, right: 8, left: 0, bottom: 0 }}
      >
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="label" tick={{ fontSize: 12 }} />
        <YAxis yAxisId="count" allowDecimals={false} tick={{ fontSize: 12 }} />
        <YAxis
          yAxisId="pct"
          orientation="right"
          tick={{ fontSize: 12 }}
          tickFormatter={(v: number) => `${v}%`}
        />
        <Tooltip formatter={percentTooltip("CR")} />
        <Legend wrapperStyle={{ fontSize: 12 }} />
        <Bar
          yAxisId="count"
          dataKey="callsDone"
          name="Call effettuate"
          fill="#C7D5F5"
          radius={[3, 3, 0, 0]}
        />
        <Bar
          yAxisId="count"
          dataKey="wonDeals"
          name="Deal vinti"
          fill="#1E429F"
          radius={[3, 3, 0, 0]}
        />
        <Line
          yAxisId="pct"
          dataKey="cr"
          name="CR"
          stroke="#DC2626"
          strokeWidth={2}
          dot={{ r: 3 }}
          connectNulls={false}
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
}

export function CapTrendChart({ weeks }: { weeks: WeekStatsDTO[] }) {
  const data = weeks.map((w) => ({
    label: weekLabel(w.weekStart),
    daysAtCap: w.daysAtCap,
    callsOverCap: w.callsOverCap,
    saturation: toPercent(capSaturation(w)),
  }));

  return (
    <ResponsiveContainer width="100%" height={260}>
      <ComposedChart
        data={data}
        margin={{ top: 16, right: 8, left: 0, bottom: 0 }}
      >
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="label" tick={{ fontSize: 12 }} />
        <YAxis yAxisId="count" allowDecimals={false} tick={{ fontSize: 12 }} />
        <YAxis
          yAxisId="pct"
          orientation="right"
          tick={{ fontSize: 12 }}
          tickFormatter={(v: number) => `${v}%`}
        />
        <Tooltip formatter={percentTooltip("Saturazione")} />
        <Legend wrapperStyle={{ fontSize: 12 }} />
        <Bar
          yAxisId="count"
          dataKey="daysAtCap"
          name="Giorni al cap"
          fill="#FCD34D"
          radius={[3, 3, 0, 0]}
        />
        <Bar
          yAxisId="count"
          dataKey="callsOverCap"
          name="Call oltre il cap"
          fill="#F97316"
          radius={[3, 3, 0, 0]}
        />
        <Line
          yAxisId="pct"
          dataKey="saturation"
          name="Saturazione"
          stroke="#047857"
          strokeWidth={2}
          dot={{ r: 3 }}
          connectNulls={false}
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
}
